module.exports = __webpack_public_path__ + "media/1500_HC_2023_Wrap_Up_and_Key_Takeaways.3b9d95b4.mp4";